import React from 'react';

function BlogModal({ blog, onClose }) {
  if (!blog) return null; // Jodi kono blog select na hoy, kichu dekhabe na

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 md:p-10 bg-deep-charcoal/90 backdrop-blur-md"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-[2rem] md:rounded-[3rem] shadow-2xl relative animate-scale-up">
        <button 
          onClick={onClose} 
          className="absolute top-6 right-6 md:top-8 md:right-8 bg-white/50 backdrop-blur-md text-deep-charcoal hover:bg-deep-charcoal hover:text-white w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center font-bold shadow-lg z-10 transition-all"
          aria-label="Close modal"
        >
          ✕
        </button>
        <div className="relative h-48 sm:h-64 md:h-96 w-full">
          <img src={blog.image_url} alt="Cover" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent"></div>
        </div>
        <div className="p-8 md:p-16 relative -mt-10 md:-mt-16 bg-white rounded-t-[2rem] md:rounded-t-[3rem]">
          <span className="text-xs font-black uppercase tracking-[0.3em] text-ocean-teal bg-ocean-teal/10 px-4 py-2 rounded-full">Psychology Insights</span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mt-8 mb-6 leading-tight text-deep-charcoal">{blog.title}</h2>
          <div className="h-1 w-20 bg-ocean-teal/30 mb-10 rounded-full"></div>
          <div className="prose prose-lg prose-headings:font-serif prose-a:text-ocean-teal text-deep-charcoal/80 leading-relaxed whitespace-pre-wrap max-w-none">
            {blog.content}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogModal;